/// <amd-module name="Search/Package/Components/PivotCommands" />

import * as Resources from "Search/Shared/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { IAggregatedState } from "Search/Package/Flux/StoresHub";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { IPivotCommands } from "Search/Shared/Components/PivotCommands";
import { ActionCreator } from "Search/Package/Flux/ActionCreator";

export function handlePivotCommands(
    pivotCommands: ObservableValue<IPivotCommands>,
    getAggregatedState: () => IAggregatedState,
    actionCreator: ActionCreator,
    isMember: boolean): void {

    const {
        filterStoreState
    } = getAggregatedState();

    const {
        toggleFilterPane
    } = actionCreator;

    const { filter, filterItemsVisible } = filterStoreState;
    const toggleButtonTooltip = filterItemsVisible ? Resources.HideFilterPanel : Resources.ShowFilterPanel;

    const filterToggle: IHeaderCommandBarItem = {
        id: "filterToggle",
        ariaLabel: toggleButtonTooltip,
        subtle: true,
        tooltipProps: { text: toggleButtonTooltip },
        iconProps: { iconName: filter.hasChangesToReset() ? "FilterSolid" : "Filter" },
        onActivate: item => toggleFilterPane()
    };

    let farItems;
    farItems = [filterToggle];
    pivotCommands.value = { farItems, items: [] };
}
